import { useQuery } from '@tanstack/react-query';

import { fetchSetupChecklist } from '../lib/setup-api';

export const setupKeys = {
  all: ['setup'] as const,
  checklist: () => [...setupKeys.all, 'checklist'] as const,
};

export function useSetupChecklist() {
  return useQuery({
    queryKey: setupKeys.checklist(),
    queryFn: fetchSetupChecklist,
    staleTime: 30_000,
  });
}
